<template>
  <div>
    <video
      id="videobox"
      class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9"
      preload="auto"
      width="100%"
      ref="videoRef"
      autoplay="false"
    >
      <p class="vjs-no-js">不支持播放</p>
    </video>
  </div>
</template>

<script>
import videojs from 'video.js';

export default {
  name: 'DetailVideo',
  data() {
    return {
      videoPath: require('../../../../../static/video.mp4'),
      videoName: 'videobox',
      player: null, // videojs播放器对象
    };
  },

  mounted() {
    let options = {
      autoplay: false,
      controls: true,
      // 配置播放源项
      sources: [
        {
          src: this.videoPath,
          type: 'video/mp4',
        },
      ],
      preload: 'auto',
      //是否显示播放按钮
      bigPlayButton: true,
      playbackRates: [0.5, 1, 1.5, 2],
      //设置小喇叭音量键
      controlBar: {
        fullscreenToggle: true,
        // 音量条的横向还是纵向显示
        volumePanel: {
          inline: false,
        },
      },
    };
    // 创建videojs对象
    let player = videojs(this.videoName, options, function onPlayerReady() {
      videojs.log('Your player is ready!');
      player.width(document.documentElement.clientWidth);
      player.height(document.documentElement.clientHeight);
    });
    this.player = player;
  },

  destroyed() {
    // 销毁实例
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
